import { useRef } from 'react';
import { useInView } from 'framer-motion';
import { ENV_CONFIG } from 'config/environment';
import { Member } from 'components/Member';
import { FadeText, FadeContainer } from 'components/CustomAnimations';

export const OurTeam = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  return (
    <div className="our-team-container">
      <div className="our-team-title">
        <FadeText inViewTrigger className="eyebrow-text" text="Our Team" />
        <FadeText inViewTrigger progressive className="h1-dtm" text="Our Founders" />
        <FadeText
          inViewTrigger
          delay={1}
          className="h4-text"
          text="Our team has decades of experience in campaigns, big data analytics, and donor advising."
        />
      </div>
      <div className="our-team-description" ref={sectionRef}>
        <img
          src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/taylor_brian.png`}
          alt="Founders"
        />
        <div className="our-team-content">
          <FadeContainer animateNow={isInView} delay={1} className="our-team-content-text">
            <FadeText className="h4-text" text="Brian Derrick" />
            <FadeText className="eyebrow-text" text="Co-founder / CEO" />
            <FadeText
              className="body-text"
              text="Brian Derrick is a political strategist, activist, and creator with a passion for helping people find their power in our electoral system . A seasoned political consultant, Derrick has consulted on campaigns from city council to president including Senator Kirsten Gillibrand (D-NY) and Congresswoman Mikie Sherrill (D-NJ)."
            />
          </FadeContainer>
          <FadeContainer animateNow={isInView} delay={1.5} className="our-team-content-text">
            <FadeText className="h4-text" text="Taylor Ourada" />
            <FadeText className="eyebrow-text" text="Co-founder / COO" />
            <FadeText
              className="body-text"
              text="Taylor Ourada is a product leader, analyst, and teacher with a passion for building insightful, data-informed products that empower grassroots donors and politicos alike. A seasoned technologist, Ourada began her career in Accenture’s Big Data practice before moving into product roles at mission-driven startups and tech implementation roles for large-scale government programs like state-based health exchanges."
            />
          </FadeContainer>
        </div>
      </div>
      <div className="our-team-title">
        <FadeText inViewTrigger progressive className="h1-dtm" text="Our Advisors" />
        <FadeText
          inViewTrigger
          delay={1}
          className="h4-text"
          text="We are supported by visionaries and experts who are helping us transform the political giving ecosystem."
        />
      </div>
      <FadeContainer animateNow={isInView} delay={2} className="our-team-advisors">
        <Member name="Alex Niemczewski" title="BallotReady" imgID="Alex" isNew />
        {/* <Member name="Ari Steinberg" title="Ex-Facebook, Airbnb" imgID="AriSteinberg" isNew /> */}
        <Member name="Ari Weinstein" title="Software Applications Incorporated" imgID="Ari" isNew />
        <Member name="Ben Horwitz" title="Causeway" imgID="Ben" isNew />
        <Member name="Betsy Hoover" title="Higher Ground Labs" imgID="Betsy" isNew />
        <Member name="Daniel Squadron" title="The States Project" imgID="Daniel" isNew />
        <Member name="Elizabeth Cutler" title="Peoplehood + SoulCycle" imgID="Elizabeth" isNew />
        <Member name="Jamie Kantrowitz" title="Strategic Advisor" imgID="Jamie" isNew />
        <Member name="Jill Lyons" title="Maximum Effort" imgID="Jill" isNew />
        <Member
          name="Ning Mosberger-Tang"
          title="1.5°Climate Strategies Group"
          imgID="Ning"
          isNew
        />
        <Member name="Rob Stavis" title="Bessemer Venture Partners" imgID="Rob" isNew />
        <Member name="Roger Ehrenberg" title="Eberg Capital" imgID="Roger" isNew />
        <Member name="Steve Klebe" title="Payments Industry Expert" imgID="Steve" isNew />
      </FadeContainer>
    </div>
  );
};
